import React, { useState } from "react";
import { Card, Select } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";

const { Option } = Select;

export const ChartMonthComparative = ({ data }) => {
  const [selectedYears, setSelectedYears] = useState([
    new Date().getFullYear(),
    new Date().getFullYear() - 1,
  ]);

  const months = Array.from({ length: 12 }, (_, index) => index);

  const getMonthlySales = (data, month, year) => {
    const sales = data.filter((item) => {
      const itemYear = new Date(
        item.dateStart.seconds * 1000 + item.dateStart.nanoseconds / 1000000
      ).getFullYear();
      const itemMonth = new Date(
        item.dateStart.seconds * 1000 + item.dateStart.nanoseconds / 1000000
      ).getMonth();
      return (
        itemYear === year && itemMonth === month && item.status === "Entregado"
      );
    });
    return sales.reduce((total, item) => total + item.saleAmount, 0);
  };

  const filteredData = data.filter((item) =>
    selectedYears.includes(
      new Date(
        item.dateStart.seconds * 1000 + item.dateStart.nanoseconds / 1000000
      ).getFullYear()
    )
  );

  const agregatedData = months?.map((month) => {
    const salesByYear = selectedYears?.reduce((acc, year) => {
      const totalSales = getMonthlySales(filteredData, month, year);
      return { ...acc, [year]: totalSales };
    }, {});
    return {
      month: new Date(0, month).toLocaleString("default", { month: "long" }),
      ...salesByYear,
    };
  });

  const years = Array.from(
    new Set(
      data.map((item) =>
        new Date(
          item.dateStart.seconds * 1000 + item.dateStart.nanoseconds / 1000000
        ).getFullYear()
      )
    )
  ).sort((a, b) => b - a);

  const handleYearChange = (index, value) => {
    const updatedYears = [...selectedYears];
    updatedYears[index] = value;
    setSelectedYears(updatedYears);
  };

  const colors = ["#2B767E", "#244861"];

  const renderCustomizedLabel = (props) => {
    const { x, y, value } = props;

    if (value === 0) {
      return null;
    }

    return (
      <text
        x={x + 37}
        y={y - 5}
        fill="#000"
        textAnchor="middle"
        dominantBaseline="start"
        style={{
          fontSize: "14px",
          transform: "rotate(315deg)",
          transformOrigin: `${x + 10}px ${y - 10}px`,
        }}
      >
        {`S/ ${value?.toFixed(2)}`}
      </text>
    );
  };

  return (
    <Card
      title="Facturación por mes"
      bordered={true}
      extra={
        <div style={{ display: "flex" }}>
          <Select
            defaultValue={selectedYears[0]}
            onChange={(value) => handleYearChange(0, value)}
          >
            {years.map((year) => (
              <Option key={year} value={year}>
                {year}
              </Option>
            ))}
          </Select>

          <Select
            defaultValue={selectedYears[1]}
            onChange={(value) => handleYearChange(1, value)}
            style={{ marginLeft: 20 }}
          >
            {years.map((year) => (
              <Option key={year} value={year}>
                {year}
              </Option>
            ))}
          </Select>
        </div>
      }
    >
      <ResponsiveContainer width="100%" height={342}>
        <BarChart data={agregatedData} margin={{ top: 60 }}>
          <CartesianGrid
            strokeDasharray="3 3"
            strokeOpacity={0.5}
            tick={{ fontSize: "15px" }}
          />
          <XAxis dataKey="month" tickFormatter={(month) => `${month}`} />
          <YAxis />
          <Tooltip formatter={(value) => `S/ $${value.toFixed(2)}`} />
          {selectedYears.map((year, index) => (
            <Bar
              key={year}
              dataKey={year}
              name={`Ventas ${year}`}
              fill={colors[index % colors.length]}
            >
              <LabelList dataKey={year} content={renderCustomizedLabel} />
            </Bar>
          ))}
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};
